import type { Role } from '@koderek/shared';
import type { ReactNode } from 'react';
import { NotFoundPage } from '../../pages/NotFoundPage';
import { RequireAuth } from './RequireAuth';
import { useMe } from './session';

/** Strona tylko dla ról (BR-07). Serwer sprawdza uprawnienia niezależnie (NFR-S4) – to wyłącznie widok. */
export function RequireRole({ roles, children }: { roles: Role[]; children: ReactNode }) {
  return (
    <RequireAuth>
      <RoleGate roles={roles}>{children}</RoleGate>
    </RequireAuth>
  );
}

function RoleGate({ roles, children }: { roles: Role[]; children: ReactNode }) {
  const me = useMe().data;
  return me && roles.some((role) => me.roles.includes(role)) ? children : <NotFoundPage />;
}

export function useHasRole(...roles: Role[]): boolean {
  const me = useMe().data;
  return !!me && roles.some((role) => me.roles.includes(role));
}
